import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme, Typography } from '@mui/material';
import { LoadingButton, LoadingButtonProps } from '@mui/lab';

const Button: FC<React.PropsWithChildren<LoadingButtonProps>> = props => {
  const { children } = props;
  const { classes } = useStyles();

  return (
    <LoadingButton
      className={classes.button}
      color='primary'
      variant='contained'
      {...props}>
      <Typography variant='body1' className={classes.innerText} noWrap>
        {children}
      </Typography>
    </LoadingButton>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  button: {
    borderRadius: theme.shape.borderRadius,
  },
  innerText: {
    textTransform: 'capitalize',
  },
}));

export default Button;
